import * as XLSX from 'xlsx';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { useNavigate } from 'react-router-dom';
import { Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { importUser } from 'redux/slices/createUser';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';

export default function ImportUser({ handleCancel, importData, setimportData, fileName, setFileName }) {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const refreshUserTab = useRefreshUserTab();
  const selectedNode = useSelector((state) => state.selectedNode);

  const beforeUpload = (file) => {
    const validExtensions = ['.xlsx', '.xls', '.csv'];
    const fileExtension = file.name.slice(((file.name.lastIndexOf('.') - 1) >>> 0) + 2);

    if (!validExtensions.includes('.' + fileExtension.toLowerCase())) {
      SweetSweetAlert({
        text: 'Invalid file type. Please upload a .xlsx, .xls, or .csv file.',
        icon: 'error',
        buttonColor: 'red',
      });
      return false || Upload.LIST_IGNORE;
    }
    setFileName(file.name);
    readExcel(file);
    return false;
  };

  const readExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const allData = [];
      workbook.SheetNames.forEach((sheetName) => {
        const xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
        allData.push(...xl_row_object);
      });

      setimportData(allData);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSubmit = async () => {
    const restructureArray = (dataArray) => {
      return dataArray.map((dataItem) => {
        const { Groups, ...userData } = dataItem;

        const user = {
          givenName: userData.givenName || '',
          initials: userData.initials || '',
          surname: userData.surname || '',
          displayName: userData.displayName || '',
          emailAddress: userData.emailAddress || '',
          userPrincipalName: userData.userPrincipalName || '',
          samAccountName: userData.samAccountName || '',
          password: userData.password || '',
          ou: userData.ou || '',
        };

        const groups = Groups ? Groups.match(/"(.*?)"/g).map((group) => group.slice(1, -1)) : [];
        return {
          userData: [user],
          addGroupNames: groups,
        };
      });
    };
    const restructuredData = restructureArray(importData);
    restructuredData.fqdn = selectedNode.domainName;
    try {
      const sweetAlert = await dispatch(importUser(restructuredData));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        Navigate('/');
        refreshUserTab();
        await handleCancel();
      } else if (sweetAlert.payload && sweetAlert.payload.error) {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        Navigate('/');
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
  };

  return (
    <div
      style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', flexDirection: 'column' }}
      className='af-import-user-wrap'
    >
      <Upload beforeUpload={beforeUpload} showUploadList={false} className='af-import-user-upload-wrap'>
        <Button
          icon={<UploadOutlined className='af-import-user-upload-icon' />}
          className='create-button af-import-user-upload-button'
        >
          Select File
        </Button>
      </Upload>
      <a href='/Users_Template.xlsx' download className='af-import-user-upload-desc-link'>
        Users_Template.xls
      </a>
      {fileName && <p className='af-import-user-upload-file-name'>{fileName}</p>}
      <span className='af-import-user-upload-file-name-info' style={{ color: 'red' }}>
        Only Upload the '.xlsx'/'.xls'or'.csv' files
      </span>
      <StyledButton
        className='af-import-user-submit-button'
        type='primary'
        disabled={importData.length === 0}
        onClick={handleSubmit}
      >
        Submit
      </StyledButton>
    </div>
  );
}
